import axios from "axios";

const API_URL = process.env.REACT_APP_QL_API_URL || 'http://localhost:3000/api';

const Auth_API = axios.create({
  baseURL: API_URL,
  timeout: 150000,
});

let store, apiResponseHandler;

// Setter to inject Redux store
export const setStore = (reduxStore) => {
  store = reduxStore;
};

// Setter to inject a custom response handler
export const setApiResponseHandler = (handler) => {
  apiResponseHandler = handler;
};

// Define publicly accessible endpoints (unauthenticated)
const PUBLIC_ENDPOINTS = ['user/login', 'user/verifyOTP','user/events/offline/ticket/details', '/user/events/offline/ViewTicket'];

// Request Interceptor
Auth_API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ql_token");
    const isPublic = PUBLIC_ENDPOINTS.some(path => config.url.includes(path));

    if (!token && !isPublic) {
      return Promise.reject(new axios.Cancel("Request canceled: No auth token."));
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    if (apiResponseHandler) {
      apiResponseHandler(error, true);
    }
    return Promise.reject(error);
  }
);

// Response Interceptor
Auth_API.interceptors.response.use(
  (response) => {
    if (apiResponseHandler) {
      apiResponseHandler(response);
    }
    return response;
  },
  (error) => {
    const isNetworkError = !error.response;
    const errorCode = error.code;
    const status = error.response?.status;

    // Check for server error status codes (500, 502, 503, 504)
    if (status && [500, 502, 503, 504].includes(status)) {
      if (apiResponseHandler) {
        apiResponseHandler(error, true);
      }
      return Promise.reject(error);
    }

    if (isNetworkError) {
      // Server downtime indicators
      const isServerDowntime = 
        errorCode === 'ERR_CONNECTION_REFUSED' || 
        errorCode === 'ECONNREFUSED' ||
        errorCode === 'ERR_NETWORK' ||
        errorCode === 'ECONNABORTED';

      if (isServerDowntime) {
        // Pass error object directly for server error detection
        if (apiResponseHandler) {
          apiResponseHandler(error, true);
        }
        return Promise.reject(error);
      }

      // Other network errors
      const message = {
        ECONNABORTED: "Request timed out. Please try again.",
        ERR_CONNECTION_REFUSED: "Cannot connect to the server. Please check your network.",
      }[errorCode] || "Session expired, please login again";

      if (apiResponseHandler) {
        apiResponseHandler({ message, code: errorCode }, true);
      }

      return Promise.reject(error);
    }

    if (apiResponseHandler) {
      apiResponseHandler(error, true);
    }

    return Promise.reject(error);
  }
);

export default Auth_API;
